var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "h-100" }, [
    _c("main", { staticClass: "card border-0 shadow-sm rounded" }, [
      _c(
        "div",
        {
          staticClass:
            "card-header bg-white py-3 d-flex flex-row align-items-center justify-content-between"
        },
        [
          _c("div", { staticClass: "d-flex align-items-center" }, [
            _c("h5", { staticClass: "mb-0 font-weight-bold text-dark" }, [
              _vm._v(_vm._s(_vm.$t("maintenance.overview2d.title")))
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "ml-3 border-left pl-3 text-muted small d-none d-lg-block"
              },
              [
                _c("i", { staticClass: "fa fa-file-image mr-1" }),
                _vm._v(
                  _vm._s(_vm.$t("maintenance.overview2d.image")) +
                    " : " +
                    _vm._s(_vm.fileName) +
                    "\n        "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex align-items-center" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex align-items-center mr-4 border-right pr-4"
                },
                [
                  _c(
                    "div",
                    { staticClass: "text-center mr-3 text-secondary" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "small text-muted text-uppercase font-weight-bold",
                          staticStyle: { "font-size": "0.65rem" }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("maintenance.overview2d.markers")) +
                              "\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "h6 mb-0 font-weight-bold" }, [
                        _c("i", { staticClass: "fa fa-map-marker-alt mr-1" }),
                        _vm._v(
                          _vm._s(_vm.state.markers.length) + "\n            "
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-center mr-3 text-success" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "small text-muted text-uppercase font-weight-bold",
                        staticStyle: { "font-size": "0.65rem" }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$t("maintenance.overview2d.healthyMarkers")
                            ) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "h6 mb-0 font-weight-bold" }, [
                      _c("i", { staticClass: "fa fa-check-circle mr-1" }),
                      _vm._v(_vm._s(_vm.healthyMarkersCount) + "\n            ")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mx-3", staticStyle: { width: "100px" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "progress",
                          staticStyle: {
                            height: "8px",
                            "background-color": "#e9ecef"
                          },
                          attrs: {
                            title: _vm.issuePercent.toFixed(1) + "% Issues"
                          }
                        },
                        [
                          _c("div", {
                            staticClass: "progress-bar bg-success",
                            style: { width: 100 - _vm.issuePercent + "%" }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "progress-bar bg-danger",
                            style: { width: _vm.issuePercent + "%" }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "text-center mt-1",
                          staticStyle: {
                            "font-size": "0.6rem",
                            "line-height": "1"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "text-muted text-uppercase font-weight-bold"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.issuePercent.toFixed(0)) +
                                  "% " +
                                  _vm._s(
                                    _vm.$t(
                                      "maintenance.overview2d.issueMarkers"
                                    )
                                  )
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-center text-danger" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "small text-muted text-uppercase font-weight-bold",
                        staticStyle: { "font-size": "0.65rem" }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$t("maintenance.overview2d.issueMarkers")
                            ) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "h6 mb-0 font-weight-bold" }, [
                      _c("i", { staticClass: "fa fa-exclamation-circle mr-1" }),
                      _vm._v(_vm._s(_vm.issueMarkersCount) + "\n            ")
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "btn-group mr-2" }, [
                _vm.modified
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-danger btn-sm",
                        on: { click: _vm.discard }
                      },
                      [
                        _c("i", { staticClass: "fa fa-undo mr-1" }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("general.discard")) +
                            "\n          "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !!_vm.state.media && _vm.modified
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn-sm",
                        on: { click: _vm.save }
                      },
                      [
                        _c("i", { staticClass: "fa fa-save mr-1" }),
                        _vm._v(" " + _vm._s(_vm.$t("btnSave")) + "\n          ")
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("ImageSelector", {
                attrs: { disabled: _vm.modified },
                on: { input: _vm.onMediaSelected }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "card-body p-0 border-top" }, [
        _c(
          "div",
          {
            staticClass: "row no-gutters",
            staticStyle: { "min-height": "500px", height: "80vh" }
          },
          [
            _c(
              "aside",
              {
                staticClass:
                  "col-12 col-md-4 col-lg-3 border-right d-flex flex-column bg-white"
              },
              [
                _c(
                  "div",
                  { staticClass: "p-3 bg-light border-bottom flex-shrink-0" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center justify-content-between mb-0"
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "font-weight-bold text-secondary text-uppercase small",
                            staticStyle: { "letter-spacing": "0.05rem" }
                          },
                          [
                            _vm._v(
                              "\n                 " +
                                _vm._s(
                                  _vm.$t("maintenance.overview2d.markers")
                                ) +
                                "\n               "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass:
                              "badge badge-pill badge-secondary small"
                          },
                          [_vm._v(_vm._s(_vm.rowsCount))]
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("MarkerList", {
                  staticClass: "flex-grow-1",
                  staticStyle: { "min-height": "0" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "section",
              {
                staticClass:
                  "col-12 col-md-8 col-lg-9 position-relative overflow-hidden bg-dark"
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "position-absolute",
                    staticStyle: { top: "15px", right: "15px", "z-index": "10" }
                  },
                  [_c("ZoomControls", { staticClass: "shadow" })],
                  1
                ),
                _vm._v(" "),
                _c("MarkerCanvas", { ref: "canvas" })
              ],
              1
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }